import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sum } from 'lodash';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import SpendingsHeader from './SpendingsHeader';
import SpendingsScreen from './SpendingsScreen';
import BudgetScreen from './BudgetScreen';

export default class SpendingsLandingPages extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    spendingAccountList: PropTypes.array,
    budgetData: PropTypes.array,
    spendListData: PropTypes.array,
    loadSpendingPage: PropTypes.number,
    totalLastMonthValue: PropTypes.array,
    totalCurrentMonthValue: PropTypes.array,
    isNoBudget: PropTypes.bool,
    allBudgetTarget: PropTypes.array,
    lastMonth: PropTypes.string,
    showAccountModal: PropTypes.bool,
    getAllAccountIds: PropTypes.array,
    openFaq: PropTypes.func,
  };

  componentDidMount() {
    sayLandingMessage('Spending');
  }

  renderLandingPageData = () => {
    const {
      totalLastMonthValue,
      totalCurrentMonthValue,
      content,
      loadSpendingPage,
      spendListData,
      isNoBudget,
      budgetData,
      allBudgetTarget,
    } = this.props;
    if (loadSpendingPage === 2 || !isNoBudget) {
      return (
        <SpendingsScreen
          content={content}
          spendListData={spendListData}
          totalLastMonthValue={sum(totalLastMonthValue).toFixed(2)}
          totalCurrentMonthValue={sum(totalCurrentMonthValue).toFixed(2)}
          isNoBudget={isNoBudget}
        />
      );
    } else {
      return (
        <BudgetScreen
          content={content}
          budgetData={budgetData}
          totalCurrentMonthValue={totalCurrentMonthValue}
          allBudgetTarget={allBudgetTarget}
          isNoBudget={isNoBudget}
        />
      );
    }
  };

  render() {
    const {
      content,
      loadSpendingPage,
      isNoBudget,
      getAllAccountIds,
      currentAccFlag,
      showAccountModal,
      spendingAccountList,
    } = this.props;
    return (
      <div className="spending main-container">
        <div className="spendings-landings">
          <div className="full-height">
            <SpendingsHeader
              loadSpendingPage={loadSpendingPage}
              isNoBudget={isNoBudget}
              spendingAccountList={spendingAccountList}
              lastMonth={this.props.lastMonth}
              content={content}
              showAccountModal={showAccountModal}
              getAllAccountIds={getAllAccountIds}
              currentAccFlag={currentAccFlag}
            />
            {this.renderLandingPageData()}
          </div>
        </div>
      </div>
    );
  }
}
